module.exports = __webpack_public_path__ + "static/images/food-and-beverage-light.8b12922bf2ff23252ff03007d7d07e8b.svg";